module.exports = __webpack_public_path__ + "img/logo13.43ddaf2e.png";